import { HttpClientResponse } from '../requests/Definitions';

export interface CancelablePromise {
  promise: Promise<HttpClientResponse>;
  cancel: () => void;
}

// https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
export const makeCancelablePromise = (promise: Promise<HttpClientResponse>): CancelablePromise => {
  let hasCanceled = false;

  const wrappedPromise = new Promise<HttpClientResponse>((resolve, reject) => {
    promise.then(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
      (val: any) => (hasCanceled ? reject({ isCanceled: true }) : resolve(val)),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
      (error: any) => (hasCanceled ? reject({ isCanceled: true }) : reject(error))
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled = true;
    },
  };
};

/**
 * settlAll uses the Promise.allSettled api, but it will throw any errors (as an array of errors) if any are
 * present from the requests.
 * @param promises an array of promises
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
export const settleAll = (promises: Promise<any>[]) =>
  // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/allSettled
  // Polyfill has been added for IE
  Promise.allSettled(promises).then((resp) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
    const errors = resp.filter((r) => r.status === 'rejected').map((r: any) => r.reason);
    if (errors && errors.length) throw errors;
    return resp;
  });
